import { useEffect, useState } from "react";
import { api, API } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { StatusPill } from "@/components/StatusPill";
import { Download } from "lucide-react";

export default function FacilityInvoices() {
  const [invoices, setInvoices] = useState([]);
  useEffect(() => { api.get("/invoices").then((r) => setInvoices(r.data)); }, []);

  return (
    <div className="space-y-6" data-testid="facility-invoices">
      <h1 className="text-3xl font-bold text-brand-navy" style={{ fontFamily: "Outfit, sans-serif" }}>Invoices</h1>
      <div className="grid gap-3">
        {invoices.map((inv) => (
          <Card key={inv.id} data-testid={`invoice-${inv.id}`}>
            <CardContent className="p-5 grid grid-cols-12 gap-3 items-center">
              <div className="col-span-12 md:col-span-3">
                <div className="font-bold text-brand-navy">{inv.invoice_number}</div>
                <div className="text-xs text-slate-500">Issued {inv.issued_date?.slice(0, 10)}</div>
              </div>
              <div className="col-span-6 md:col-span-3 text-sm text-slate-600">Due: {inv.due_date}</div>
              <div className="col-span-6 md:col-span-2 text-lg font-bold text-brand-navy">${inv.total.toFixed(2)}</div>
              <div className="col-span-6 md:col-span-2"><StatusPill status={inv.status} /></div>
              <div className="col-span-6 md:col-span-2 flex md:justify-end">
                <a href={`${API}/invoices/${inv.id}/pdf`} target="_blank" rel="noreferrer">
                  <Button variant="outline" size="sm" data-testid={`invoice-pdf-${inv.id}`}><Download className="w-4 h-4 mr-1" />PDF</Button>
                </a>
              </div>
            </CardContent>
          </Card>
        ))}
        {invoices.length === 0 && <div className="text-center py-16 text-slate-500">No invoices yet.</div>}
      </div>
    </div>
  );
}
